import { render, staticRenderFns } from "./WorkweekPage.vue?vue&type=template&id=667e2410"
import script from "./WorkweekPage.vue?vue&type=script&lang=js"
export * from "./WorkweekPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports